// Devices.js
import React, { useState, useEffect } from 'react';
import { Layout, Table, Typography, Spin, message, Input, Select } from 'antd';
import { fetchWithDeviceId } from './utils/deviceId';

const { Content } = Layout;
const { Title } = Typography;
const { Option } = Select;

const Devices = () => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);

  // 获取设备列表
  const fetchDevices = async () => {
    setLoading(true);
    try {
      const response = await fetchWithDeviceId(`${process.env.REACT_APP_API_BASE}/api/devices/list`);
      if (response.ok) {
        const data = await response.json();
        // 假设 data 是数组，每项包含 device_id, authorized, nickname
        setDevices(data);
      } else {
        message.error('获取设备列表失败');
      }
    } catch (error) {
      console.error(error);
      message.error('获取设备列表出错');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDevices();
  }, []);

  // 更新设备数据
  const updateDevice = async (deviceId, updatedData) => {
    try {
      const response = await fetchWithDeviceId(`${process.env.REACT_APP_API_BASE}/api/devices/update`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ device_id: deviceId, ...updatedData })
      });
      const result = await response.json();
      if (response.ok && result.success) {
        message.success('设备更新成功');
      } else {
        message.error(result.error || '设备更新失败');
      }
    } catch (error) {
      console.error(error);
      message.error('更新设备出错');
    }
  };

  // 表格列定义
  const columns = [
    {
      title: '设备编号',
      dataIndex: 'device_id',
      key: 'device_id',
      width: 150,
    },
    {
      title: '首次登录时间',
      dataIndex: 'first_login_time',
      key: 'first_login_time',
      width: 150,
    },
    {
      title: '授权状态',
      dataIndex: 'authorized',
      key: 'authorized',
      width: 150,
      render: (text, record) => (
        <Select
          value={record.authorized}
          onChange={(value) => {
            // 更新本地状态
            setDevices(prev =>
              prev.map(dev =>
                dev.device_id === record.device_id ? { ...dev, authorized: value } : dev
              )
            );
            updateDevice(record.device_id, { authorized: value });
          }}
          style={{ width: '100%' }}
        >
          <Option value={1}>授权</Option>
          <Option value={0}>未授权</Option>
        </Select>
      ),
    },
    {
      title: '设备昵称',
      dataIndex: 'nickname',
      key: 'nickname',
      width: 200,
      render: (text, record) => (
        <Input
          defaultValue={text}
          onBlur={(e) => {
            const newNickname = e.target.value;
            if (newNickname !== record.nickname) {
              setDevices(prev =>
                prev.map(dev =>
                  dev.device_id === record.device_id ? { ...dev, nickname: newNickname } : dev
                )
              );
              updateDevice(record.device_id, { nickname: newNickname });
            }
          }}
        />
      ),
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Content style={{ padding: '40px 80px' }}>
        <Title level={1}>设备管理</Title>
        <Spin spinning={loading}>
          <Table
            dataSource={devices.map(device => ({ ...device, key: device.device_id }))}
            columns={columns}
            pagination={false}
            bordered
          />
        </Spin>
      </Content>
    </Layout>
  );
};

export default Devices;
